import React from 'react'

import './styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ProgressiveButton extends React.Component {
  state = {
    done: false,
    cn: '',
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.percent < 100 && nextProps.percent === 100) {
      setTimeout(() => {
        this.setState({
          cn: 'progressive-button',
        })
      }, 500)

      setTimeout(() => {
        this.setState({
          cn: '',
        })

        this.setState({
          done: true,
        })
      }, 2000)
    }
  }

  render() {
    const language = this.props.language || {}

    return (
      <button
        className={`btn btn-info progressive-button-container mr-1 ${this.state.cn}`}
        style={{ position: 'relative', overflow: 'hidden' }}
        form={this.props.form || ''}
        type={this.props.type || ''}
      >
        {this.props.percent ? (
          <span
            className={`uploading-video-percent-bg ${this.state.cnColor}`}
            style={{ width: this.props.percent + '%' }}
          ></span>
        ) : null}
        <span className='upload-video-text progressive-button-text'>
          {this.props.percent === 100 && this.state.done
            ? language.courses
              ? language.courses.processing
              : null
            : this.props.status
            ? language.courses
              ? language.courses.uploading
              : null
            : this.props.placeholder}
        </span>
        <span className='progressive-button-done'>
          <FontAwesomeIcon icon='check' className='icon' />
        </span>
      </button>
    )
  }
}

export default ProgressiveButton
